import { render, staticRenderFns } from "./UiSegment.vue?vue&type=template&id=b8e6e84e"
import script from "./UiSegment.vue?vue&type=script&lang=js"
export * from "./UiSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports